import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/mocuts/features_back.webp";

function Challenge() {
  return (
    <div
      className="challenge_section features_mocuts p-100 text_mocuts"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="ms-auto my-auto">
            <h2>
              Platform <span>Features</span>
            </h2>
            <ul>
              <li>
                We then had to integrate both app versions into the client's
                dashboard, where they could administer all the activities on
                their platform and add or remove users and service providers
                violating the platform's policies.
              </li>
              <li>
                The client also wanted to add the live tracking feature, where
                users could track the service provider's location and estimate
                arrival time using GPS.
              </li>
              <li>
                Simply put, the client wanted an Uber-like on-demand application
                for salon services with all the advanced features that enable
                consumers to order services from the comfort of their homes
                seamlessly.
              </li>
              <li>
                We started the project by creating wireframes and delivered a
                prototype for approval. After getting the go-ahead from the
                client, we proceeded with development and API integration and
                completed both Android and iOS versions of the app for launch
                and deployment.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Challenge;
